<template>
    <Head title="Create New Question"/>
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl leading-tight">
                Create New Question
            </h2>
        </template>

        <BreadCrumbs :items="navItems"></BreadCrumbs>

        <div class="w-full my-6 rounded py-12 shadow-lg">
            <div class="px-6 pt-4 pb-2">
                <form enctype="multipart/form-data"
                      @submit.prevent="create.post(requestUrl, { preserveScroll: true})"
                      class="w-full">
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Title</admin-app-label>
                            <input-basic
                                placeholder="Title"
                                v-model="create.title"
                                :error="errors['title']"
                            />
                            <input-error v-if="errors['title']">
                                {{ errors.title }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Question</admin-app-label>
                            <input-basic
                                placeholder="Question"
                                v-model="create.question"
                                :error="errors['question']"
                            />
                            <input-error v-if="errors['question']">
                                {{ errors.question }}
                            </input-error>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Product Type</admin-app-label>
                            <input-select
                                placeholder="Product Type"
                                labelKey="Product Type"
                                label="label"
                                :options="productTypes"
                                :reduce="(productTypes) => productTypes.id"
                                v-model="create.product_type"
                            ></input-select>
                            <input-error v-if="errors['product_type']">
                                {{ errors.product_type }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Question Type</admin-app-label>
                            <input-select
                                placeholder="Question Type"
                                labelKey="Question Type"
                                label="label"
                                :options="questionTypes"
                                :modelValue="questionType"
                                :error="errors['type']"
                                :reduce="(questionTypes) => questionTypes.id"
                                v-model="create.type"
                            ></input-select>
                            <input-error v-if="errors['type']">
                                {{ errors.type }}
                            </input-error>
                        </div>
                    </div>

                    <div class="flex items-center">
                        <input-checkbox class="mr-1" v-model="create.required">
                            Required
                        </input-checkbox>
                    </div>

                    <app-button type="submit" class="mt-8">Create</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
<script>
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import InputError from "@/Components/Forms/Inputs/InputError";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import {Head, useForm} from "@inertiajs/inertia-vue3";
import BreezeAuthenticatedLayout from "@/Layouts/Admin/Authenticated.vue";
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";
import AppButton from "@/Components/AppButton";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import InputCheckbox from "@/Components/Forms/Inputs/InputCheckbox";

export default {
    components:
        {
            BreadCrumbs,
            AppButton,
            InputSelect,
            InputError,
            InputBasic,
            AdminAppLabel,
            Head,
            BreezeAuthenticatedLayout,
            InputCheckbox
        },
    props: {
        errors: Object,
        questionType: String,
        productType: String,
        requestUrl: {
            type: String,
            default: "/admin/questions"
        }
    },
    data() {
        return {
            navItems: [
                {title: "Questions", path: "/admin/questions"},
                {title: "New Question", path: "/admin/questions/create"}
            ],
            productTypes: [
                {label: "Fitter", id: "fitter"},
                {label: "Tyre", id: "tyre"},
                {label: "Website", id: "website"},
                {label: "Product", id: "product"}
            ],
            questionTypes: [
                {label: "Rating", id: "rating"},
                {label: "Yes / No", id: "yesno"},
                {label: "Answer", id: "answer"}
            ],
            create: useForm(
                {
                    title: "",
                    question: "",
                    product_type: null,
                    type: null,
                    required: true
                }
            )
        };
    }
};
</script>
